import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store/store'
import Spinner from 'vue-simple-spinner'
import notie from 'notie'
import axios from 'axios'
import tabs from '@/components/Tabs.vue'
import tab from '@/components/Tab.vue'
import formGenerator from '@/components/FormGenerator.vue'
import ShowmanTable from '@/components/ShowmanTable.vue'
import DropdownButton from '@/components/DropdownButton.vue'
import DatePicker from 'vue2-datepicker'
import ShareButton from '@/components/ShareButton.vue'
import {BModal} from 'bootstrap-vue'
// import BModalDirective from 'bootstrap-vue/es/directives/modal/modal'

import Multiselect from 'vue-multiselect'
import VueFormGenerator from 'vue-form-generator'
import VTooltip from 'v-tooltip'

import '@/assets/css/tailwind.css'
import '@/assets/css/transistions.css'
import '@/assets/css/bootstrap-modal.css'
import '@/assets/css/tooltip.css'
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'vue-select/dist/vue-select.css'
import 'vue2-datepicker/index.css'

// import HoneybadgerVue from '@honeybadger-io/vue'
import vSelect from 'vue-select'
import DisplayFileTypeField from '@/components/DisplayFileTypeField.vue'

import * as Fathom from 'fathom-client'
import * as Localized from './localizationConfig'
import * as UserAccess from './userAccessLevel'

// prerender
// window.prerenderReady = false

// Upon initial page load...
Fathom.load('WWZHYRHZ')

// import VJsoneditor from 'v-jsoneditor'
/* const config = {
  apiKey: '50ea79d3',
  environment: process.env.NODE_ENV,
  revision: process.env.VUE_APP_GIT_VERSION
} */

/* if (process.env.NODE_ENV !== 'development') {
  Vue.use(HoneybadgerVue, config)

  Vue.$honeybadger.beforeNotify((notice) => {
    if (process.env.NODE_ENV === 'development') {
      // // console.log(notice)
    }
  })
} */

Vue.config.productionTip = false
/* Vue.config.errorHandler = function (err, vm, info) {
  Vue.$honeybadger.notify(err)
} */

// Vue.use(VJsoneditor)

Vue.component('date-picker', DatePicker)

Vue.component('vue-simple-spinner', Spinner)
Vue.component('tab', tab)
Vue.component('tabs', tabs)
Vue.component('form-generator', formGenerator)
Vue.component('showman-table', ShowmanTable)
Vue.component('dropdown-button', DropdownButton)
Vue.component('share-button', ShareButton)
// Vue.component('new-dropdown-button', NewDropdownButton)
Vue.component('multiselect', Multiselect)
Vue.use(VueFormGenerator)
Vue.use(VTooltip, {
  defaultHideOnTargetClick: true
})
Vue.component('v-select', vSelect)
Vue.component('display-file-type-field', DisplayFileTypeField)

Vue.component('b-modal', BModal)
// Vue.directive('b-modal', BModalDirective)

Vue.prototype.axios = axios
Vue.prototype.Fathom = Fathom
Vue.prototype.notie = notie
Vue.prototype.formatGrade = (grade) => {
  if (grade === 1) {
    return '1st'
  } else if (grade === 2) {
    return '2nd'
  } else if (grade === 3) {
    return '3rd'
  } else {
    return `${grade}th`
  }
}
Vue.prototype.linkify = function linkify (text) {
  var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
  return text.replace(exp, "<a class='link break-all' href='$1' target='_blank'>$1</a>")
}

// Quick Fix
Vue.prototype.filterRingDivisions = function (showBook, ringID, ringSettings) {
  if (ringSettings) {
    if (ringSettings.length > 1) {
      let ring = null
      if (ringID === 'Overall') {
        showBook.forEach(c => {
          if (c.division !== 'Overall') {
            c.hide = true
          } else {
            c.hide = false
          }
        })
      } else {
        if (ringID) {
          if (ringID !== 'All Rings') {
            ringSettings.forEach(r => {
              if (r.name === ringID) {
                ring = r
              }
            })
          }
        } else {
          ring = ringSettings[0]
        }
        if (ring) {
          if (ring.divisions) {
            if (ring.divisions.length) {
              showBook.forEach(c => {
                if (!ring.divisions.includes(c.division)) {
                  c.hide = true
                } else {
                  c.hide = false
                }
              })
            }
          }
        }
      }
    }
  }
  return showBook
}

function hasDuplicates (array) {
  return (new Set(array)).size !== array.length
}

Vue.prototype.fixEntryGrouping = function fixEntryGrouping (entryGroup) {
  let newEntries = []
  entryGroup.entries.forEach(e => {
    if (hasDuplicates(e.shows)) {
      const counts = {}
      e.shows.forEach(s => {
        counts[s] = counts[s] ? counts[s] + 1 : 1
      })
      let entryCopy = JSON.parse(JSON.stringify(e))

      entryCopy.shows.forEach((s, i) => {
        if (counts[s] > 1) {
          let newEntry = JSON.parse(JSON.stringify(e))
          newEntry.shows = [s]
          newEntry.entry_ids = [entryCopy.entry_ids[i]]
          newEntries.push(newEntry)
          // remove from original entry
          e.shows.splice(i, 1)
          e.entry_ids.splice(i, 1)
          counts[s] -= 1
        }
      })
      newEntries.push(e)
    } else {
      newEntries.push(e)
    }
  })
  entryGroup.entries = newEntries
  return entryGroup
}
Vue.prototype.Localized = Localized.default
Vue.prototype.UserAccess = UserAccess.default

Vue.prototype.getParameterByName = function getParameterByName (name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  var results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
